<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">新規登録に関して</h5>
                    <HelpMenuItem menuTitle="Q．メールアドレスを使用して新規登録したいです。" menuId="1">
                        <p>新規登録の手順は以下の通りです。</p>
                        <p>1. 会員登録方法選択画面でメールアドレス・メールアドレス（確認）を入力の上、「メールアドレスで登録」をクリック。</p>
                        <p>2. 仮登録完了画面に移動します。同時に、仮登録送信メールが届きますので、メール本文にあるリンクをクリックして下さい。</p>
                        <p>3. 必要事項を入力し、利用規約を読んでいただいた上「利用規約に同意」にチェックし、「登録内容確認へ」をクリック。</p>
                        <p>4. 入力内容に誤りがないかチェックして下さい。誤りがある場合、「修正」をクリック。誤りがなければ、「登録」をクリック。</p>
                        <p>5. 会員登録完了画面に移動で、完了。</p>
                        <p>【注意点】 </p>
                        <p>- 既にご登録頂いているメールアドレスでは、重複登録とエラーが表示され登録できません。</p>
                        <p>- お客様お一人につき、１つのユーザーアカウントでのご利用をお願い致します。</p>
                    </HelpMenuItem>
                    <!-- クラシック用にコメントアウト -->
                    <!-- <HelpMenuItem menuTitle="Q．LINEを使用して新規登録したいです。" menuId="2">
                        <p>新規登録の手順は以下の通りです。</p>
                        <p>1. 会員登録方法選択画面で「LINEで登録」をクリックして下さい。</p>
                        <p>2. LINEの画面に進みますので、必要事項をご入力ください。LINEで認証されますと会員登録画面へ進みます。</p>
                        <p>3. 必要事項を入力し、利用規約を読んでいただいた上「利用規約に同意」にチェックし、「登録内容確認へ」をクリック。</p>
                        <p>4. 入力内容に誤りがないかチェックして下さい。誤りがある場合、「修正」をクリック。誤りがなければ、「登録」をクリック。</p>
                        <p>5. 会員登録完了画面に移動で、完了。</p>
                        <p>【注意点】 </p>
                        <p>- 既にご登録頂いているメールアドレスでは、重複登録とエラーが表示され登録できません。</p>
                        <p>- お客様お一人につき、１つのユーザーアカウントでのご利用をお願い致します。</p>
                    </HelpMenuItem> -->
                    <HelpMenuItem menuTitle="Q．仮登録メールが届きません。" menuId="3">
                        <p>下記の原因が想定されます。対策方法をご確認ください。</p>
                        <p>■主に想定される原因 </p>
                        <p>    1．ご入力いただいたメールアドレスが間違っている場合。</p>
                        <p>    2．迷惑メールフォルダに振り分けられた場合。</p>
                        <p>    3．セキュリティソフトでブロックされてた場合。</p>
                        <p>    4．プロバイダー様にて特定メールをフィルタリングされている場合。</p>
                        <p>    5．メールボックスの容量オーバーで、受信できない状態にある場合。</p>
                        <p>■対策方法</p>
                        <p>    1．メールアドレスをご確認の上、正しいアドレスにて再度登録する。</p>
                        <p>    2．迷惑メールフォルダーを確認する。</p>
                        <p>    3．セキュリティソフトの設定を確認する。</p>
                        <p>    4．ドメインを受信許可する。</p>
                        <p>    5．一杯になっている受信フォルダを整理する。</p>
                        <p>■ご注意ください！</p>
                        <p>・仮ユーザー情報は24時間経過すると自動削除されます。</p>
                        <p>    自動削除された場合、URLをクリックしても本登録されません。</p>
                        <p>    その場合は再度新規登録操作を行ってください。</p>
                        <p>上記内容をご確認の上、改善されない場合、お手数ですが下記宛に</p>
                        <p>お問い合わせください。</p>
                        <p><a :href="`mailto:${info_mail}`">{{ info_mail }}</a></p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．「入力したメールアドレスは既に登録されています」というエラーが出ます。" menuId="4">
                        <p>ご入力いただいたメールアドレスは既にご登録をいただいている可能性があります。</p>
                        <p>１つのメールアドレスにつき、１ユーザーアカウントのみのご登録となります。 </p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．仮登録とは何ですか？" menuId="5">
                        <p>『仮登録』とは、会員登録の手続きの過程にあり、登録が完了していない状態のことです。</p>
                        <p>入力したメールアドレスに一旦確認メールを配信し、確認メールに記載された所定のURLにアクセスすることで</p>
                        <p>メール配信の環境・アドレスが適切か否かを判断しています。</p>
                        <p>「本登録URL」メールのリンクをクリック、登録完了画面に移動すると、完了になります。</p>
                        <p>■ご注意ください！</p>
                        <p>・メール内のURLをクリックしてもWebサイトが表示されない場合は、URLをコピーし、直接ブラウザのアドレスバーに貼り付けてください。URLの前後にスペースが入らないようご注意下さい。</p>
                        <p>・仮ユーザー情報は24時間経過すると無効となります。無効となった場合、URLをクリックしても本登録されません。その場合は再度新規登録操作を行ってください。 </p>
                        <p>・メールが届かない場合は、迷惑メールフォルダに入っていないかご確認ください。</p>
                        <p>・受信できない場合、ドメインを受信許可してください。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．家族で同じメールアドレスを利用しています。" menuId="6">
                        <p>ROUNDNAVI WEBでは、1つのメールアドレスにつき1つのアカウントとなりますので、</p>
                        <p>同じメールアドレスで複数のユーザー登録は出来ません。</p>
                        <p>別のメールアドレス(Webメールでも可)をご用意の上、ご登録ください。</p>
                    </HelpMenuItem>
                </div>
            </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
        </div>
    </div>
</div>

</template>

<script>
import HelppageSideMenu from './HelppageSideMenu';
import HelpMenuItem from './components/HelpMenuItem';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
            info_mail: process.env.MIX_SUPPORT_MAILADDRESS
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
        
    }
}

</script>